<template>
  <AuthShell ref="auth" mode="register">
    <el-form :disabled="submitting || codeBusy" :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent="submitForm('ruleForm')">
      <label class="auth-label" for="register-mobile">手机号</label>
      <el-form-item prop="mobile"><el-input id="register-mobile" v-model="ruleForm.mobile" type="tel" autocomplete="tel" placeholder="请输入手机号码" /></el-form-item>
      <label v-if="smsRequired" class="auth-label" for="register-code">验证码</label>
      <el-form-item v-if="smsRequired" prop="code"><div class="auth-code-field"><el-input id="register-code" v-model="ruleForm.code" autocomplete="one-time-code" placeholder="请输入验证码" /><el-button class="auth-code-button" :disabled="codeBusy || !!times" @click="getCode">{{ codeBusy ? '发送中…' : typeof showCode === 'number' ? showCode + '秒后重试' : showCode }}</el-button></div></el-form-item>
      <label class="auth-label" for="register-invite">邀请码</label>
      <el-form-item prop="invide_code"><el-input id="register-invite" v-model="ruleForm.invide_code" autocomplete="off" :placeholder="inviteRequired ? '请输入邀请码（必填）' : '邀请码（选填）'" /></el-form-item>
      <div class="auth-password-grid">
        <div><label class="auth-label" for="register-password">密码</label><el-form-item prop="password"><el-input id="register-password" v-model="ruleForm.password" type="password" autocomplete="new-password" placeholder="设置登录密码" show-password /></el-form-item></div>
        <div><label class="auth-label" for="register-confirm">确认密码</label><el-form-item prop="checkPassword"><el-input id="register-confirm" v-model="ruleForm.checkPassword" type="password" autocomplete="new-password" placeholder="再次输入密码" show-password /></el-form-item></div>
      </div>
      <el-button :loading="submitting" :disabled="submitting || codeBusy" type="primary" class="auth-submit" native-type="submit">注册账号</el-button>
    </el-form>
  </AuthShell>
</template>

<script>
import AuthShell from './AuthShell.vue'
import authSecurity from '@/utils/authSecurity'

import {apiRegister} from '@/utils/requestapis'
import Router from "@/router";

export default {
  components: { AuthShell },
  mixins: [authSecurity],
  data() {
    var validateCode = (rule, value, callback) => {
      if (this.smsRequired && value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入手机号'));
      } else if (value.length < 11) {
        callback(new Error('手机号输入不一致!'));
      } else {
        callback();
      }
    };
    var validateICode = (rule, value, callback) => {
      if (this.inviteRequired && value === '') {
        callback(new Error('请输入邀请码'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.password != value) {
          callback(new Error('输入的确认密码有误'));
        }else {
          callback();
        }
      }
    };
    return {
      showCode:'获取验证码',
      times:false,
      codeBusy:false,
      disposed:false,
      checkList:[],
      activeName:'first',
      ruleForm: {
        mobile: '',
        code: '',
        invide_code:'',
        password:'',
        checkPassword:''
      },
      rules: {
        mobile: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        invide_code: [
          { validator: validateICode, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validateCheckPass, trigger: 'blur' }
        ]
      }
    };
  },
  beforeDestroy() { this.disposed = true; clearInterval(this.times) },
  methods: {
    getCode2(){
      this.showCode--;
      if(this.showCode <= 0){
        this.showCode = '获取验证码';
        clearInterval(this.times);
        this.times = false;
      }
    },
    async getCode() {
      if (this.submitting || this.codeBusy || this.times) return
      if(!/^\d{11}$/.test(this.ruleForm.mobile)){
          this.$message({
            message: '请输入11位手机号',
            type: 'error',
            duration: 5 * 1000
          })
        return 0;
      }
      let param = {
        mobile:this.ruleForm.mobile,
        type:1
      }
      this.codeBusy = true
      try {
        const result = await this.sendVerifiedCode(param.mobile, param.type)
        if (!result || this.disposed) return
        this.showCode = 60
        this.times = setInterval(this.getCode2,1000)
      } catch (_) { /* The shared request handler displays the error. */ }
      finally { this.codeBusy = false }
    },
    handleClick(){
      this.$router.push('/Login').catch(err=>{})
    },
    async submitForm(formName) {
      if (this.submitting || this.codeBusy) return
      this.submitting = true
      try {
        const valid = await new Promise(resolve => this.$refs[formName].validate(resolve))
       // console.log(this.ruleForm);
        if (valid) {
          await apiRegister({ ...this.ruleForm, code: this.smsRequired ? this.ruleForm.code : '' }).then((res) => {
            //if (!res) return
            this.$alert('注册成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  Router.push('/login').catch(err=>{})
                }
            });
            // console.log(res)
            // if(res.code === 500){
            //   this.$message({
            //     message: res.msg,
            //     type: 'error',
            //     duration: 5 * 1000
            //   })
            // }else {
            //   this.$alert('注册成功', '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {
            //       Router.push('/login').catch(err=>{})
            //     }
            //   });
            // }

          }).catch(() => {})
        } /*else {
          console.log('error submit!!');
          return false;
        }*/
      } finally { this.submitting = false }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
